import axios from 'axios'
const token = localStorage.getItem('token')
import router from '../../router'
import { app } from '../../main'

const state = {
	settings: []
}

const mutations = {
       SET_SETTINGS_DATA (state, { settings }){
           state.settings = settings
      },
      onEditGeneralSettings(state, setting){
          let vm = this;
          $(':input').prop('disabled', true)
          axios.post('setting/general/edit?token=' + token, setting, { headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json'} })
            .then(function (response) {
                $(':input').prop('disabled', false)
                Ladda.stopAll()
                vm.dispatch('loadDataSettings')
                app.notify('success_edit')
            })
            .catch(function (error) {
                $(':input').prop('disabled', false);
                Ladda.stopAll()
                app.notify('error_edit')
            });
      },
      onEditPlayerSettings(state, setting){
          let vm = this;
          $(':input').prop('disabled', true)
          axios.post('setting/player/edit?token=' + token, setting, { headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json'} })
            .then(function (response) {
                $(':input').prop('disabled', false)
                Ladda.stopAll()
                vm.dispatch('loadDataSettings')
                app.notify('success_edit')
            })
            .catch(function (error) {
                $(':input').prop('disabled', false);
                Ladda.stopAll()
                app.notify('error_edit')
            });
      },
      onEditAdvertisementSettings(state, setting){
          let vm = this;
          $(':input').prop('disabled', true)
          axios.post('setting/ads/edit?token=' + token, setting, { headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json'} })
            .then(function (response) {
                $(':input').prop('disabled', false)
                Ladda.stopAll()
                vm.dispatch('loadDataSettings')
                app.notify('success_edit')
            })
            .catch(function (error) {
                $(':input').prop('disabled', false);
                Ladda.stopAll()
                app.notify('error_edit')
            });
      },
      onEditCaptionsSettings(state, setting){
          let vm = this;
          $(':input').prop('disabled', true)
          axios.post('setting/captions/edit?token=' + token, setting, { headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json'} })
            .then(function (response) {
                $(':input').prop('disabled', false)
                Ladda.stopAll()
                vm.dispatch('loadDataSettings')
                app.notify('success_edit')
            })
            .catch(function (error) {
                $(':input').prop('disabled', false);
                Ladda.stopAll()
                app.notify('error_edit')
            });
      }
      //
}

const actions = {
    loadDataSettings({ commit }) {
        let vm = this;
        axios.get('setting/list?token=' + token)
          .then(function (response) {
              commit('SET_SETTINGS_DATA', { settings: response.data.settings });
              //console.log(response)
          })
          .catch(function (error) {
              if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem('token')
                router.go('/')
              }
              else{
                Swal.fire("Notification", "Error retrieving data, please try reloading the page!", "error")
              }
              //console.log(error)
          });
	  }
}

const getters = {
    settings: state => {
      return state.settings
    }
}

export default {
	state,
	mutations,
	actions,
	getters
}


// WEBPACK FOOTER //
// ./src/store/modules/settings.js